module.exports = __webpack_public_path__ + "img/1.27ec0034.jpg";